<template>
  <div class="ion-page">
    <ion-header class="ion-no-border" v-if="asset.banner">
      <ion-toolbar class="ion-no-border toolbar-transparent">
        <ion-buttons slot="end">
          <ion-button @click="onCancel">
            <ion-icon slot="start" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
      <div
        class="asset-landing-banner"
        :style="{
          'background-image': 'url(' + getSrc(asset.banner.key) + ')'
        }"
      ></div>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-grid>
        <ion-row>
          <ion-col>
            <div class="text-center">
              <h1 class="asset-landing-title" v-if="asset.title">
                {{ asset.title }}
              </h1>
              <h4 class="asset-landing-subtitle" v-if="asset.subtitle">
                {{ asset.subtitle }}
              </h4>
              <p class="asset-landing-last">
                Last inspection:
                {{ formatInspectionDate(asset.last_inspection_date) }}
              </p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer class="ion-no-border">
      <ion-toolbar class="ion-no-border">
        <div class="ion-padding text-center">
          <div class="text-container">
            <ion-note>Powered by StayOnHire</ion-note>
          </div>
          <ion-button
            expand="block"
            @click="onStart"
            :disabled="!asset.inspection_prestart_form"
            >Begin Prestart</ion-button
          >
        </div>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
  props: ["asset"],
  methods: {
    formatInspectionDate(iso) {
      if (iso) {
        return DateTime.fromISO(iso).toFormat("d LLL y, hh:mm a");
      }
      return "N/a";
    },
    getSrc(key) {
      return process.env.VUE_APP_USERCONTENT_ORIGIN + `/${key}`;
    },
    onCancel() {
      this.$router.push("/");
    },
    onStart() {
      this.$emit("start");
    }
  }
};
</script>

<style lang="scss" scoped>
.asset-landing {
  &-title {
    font-weight: bold;
  }
  &-banner {
    height: 36vh;
    background-size: cover;
    background-position: center;
    background-repeat: none;
  }
  &-last {
    font-size: 0.9em;
  }
}
</style>
